import config from '@/config';
import axios from 'axios';

const { get, post, patch } = axios;

export const getRegistry = projectId => get(`/v1/projects/${projectId}/registry/pathway/`);
export const getSubpathwayRegistry = (caseId, nodeId) => get(`/v1/cases/${caseId}/nodes/${nodeId}/registry/pathway/`);
export const getSpecies = () => get('/v1/registry/species/');
export const addCustomModel = data => post('/v1/custom_models/', data);
export const validateCustomModel = data => post('/v1/custom_models/validate/', data);
export const testCustomModel = data => post('/v1/custom_models/test/', data);
export const getCustomModels = () => get('/v1/custom_models/');
export const getCustomModel = customId => get(`/v1/custom_models/${customId}/`);
export const updateCustomModel = (customId, data) => patch(`/v1/custom_models/${customId}/`, data);
export const deleteCustomModel = customId => axios.delete(`/v1/custom_models/${customId}/`);
export const removeModel = id => axios.delete(`/v1/custom_models/${id}/`);

export const createExcelModel = data => post('/v1/excel_models/', data);
export const exportCustomModel = modelId => `${config.serverUrl}/v1/custom_models/${modelId}/download/`;
export const convertAspenModel = data => post('/v1/aspen_models/', data);
